<kendo-dropdownbutton
  [data]="languageSwitcherService.languages"
  [textField]="'title'"
  class="bg-white border-gray-300 language-dropdown-selector"
  (itemClick)="onLanguageChange($event)"
>
  <span [class]="shouldBeExtended() ? 'inline-flex items-baseline' : ''">
    <span class="mx-1 emojiFlag">{{
      languageSwitcherService.selectedLanguage.getValue().emoji
    }}</span>
    @if (shouldBeExtended()) {
      <span>{{
        languageSwitcherService.selectedLanguage.getValue().title
      }}</span>
    }
  </span>
  <ng-template kendoDropDownButtonItemTemplate let-dataItem>
    <span [class]="'inline-flex items-baseline'">
      <span class="mx-1 emojiFlag">{{ dataItem?.emoji }}</span>
      <span>{{ dataItem?.title }}</span>
    </span>
  </ng-template>
</kendo-dropdownbutton>
